import { useParams } from 'react-router-dom';

export const useIsFilterAllowed = () => {
  const filterExclusionSlugs = ['dimensions-legacy', 'industry-standards'];
  const { slug } = useParams();

  const isFilterAllowed = !filterExclusionSlugs.includes(slug || '');
  return isFilterAllowed;
};
